import { axiosPrivate } from "@/api/axios";
import { FactApiEntity } from "../types";

export async function fetchFactsByType(type: string): Promise<FactApiEntity[]> {
  const response = await axiosPrivate.get(`/facts/type/${type}`);
  const payload = Array.isArray(response.data?.data) ? response.data.data : response.data;
  return Array.isArray(payload) ? (payload as FactApiEntity[]) : [];
}

export async function deleteFact(id: number): Promise<void> {
  await axiosPrivate.delete(`/facts/${id}/`);
}
